import { NotFoundPageComponent } from './_core/components/404/not-found-page.component';
import { NotFoundGuard } from './_core/components/404/not-found-page.guard';
import { UnauthorizedPageComponent } from './_core/components/403/unauthorized-page.component';
import { LandingPageComponent } from './_core/components/landing-page/landing-page.component';
import { RootPageGuard } from './_core/services/root-page.guard';
import { ServerDownPageComponent } from './_core/components/502/server-down-page.component';
import { ServerDownPageGuard } from './_core/components/502/server-down-page.guard';

export const APP_ROUTES = [
    { path: '404', component: NotFoundPageComponent, canActivate: [NotFoundGuard] },
    { path: '502', component: ServerDownPageComponent, canActivate: [ServerDownPageGuard] },
    { path: '403', component: UnauthorizedPageComponent, canActivate: [NotFoundGuard] },
    { path: '', component: LandingPageComponent, canActivate: [RootPageGuard] },
    {
        path: 'redirect-page',
        loadChildren: () => import('./redirect-page/redirect-page.module').then(m => m.RedirectPageModule),
    },
    { path: ':portalID', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
    { path: ':portalID/account', loadChildren: () => import('./account-request/account-request.module').then(m => m.AccountRequestModule) },
    { path: ':portalID/:version/order', loadChildren: () => import('./order/order.module').then(m => m.OrderModule) },
    { path: ':portalID/order', loadChildren: () => import('./order/order.module').then(m => m.OrderModule) },
    { path: '**', redirectTo: '404' },
];
